import {
  Job13y4jkazwjho0 as Job,
  Key_instancepi2bbb0csu5f as Key_instance,
  ensureActive2yo7199srjlgl as ensureActive,
} from './Job.mjs';
import {
  ContextScoper0znlsj7ufhq as ContextScope,
  ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine,
} from './internal/Scopes.mjs';
import { startUndispatchedOrReturn1od7ryhr362dr as startUndispatchedOrReturn } from './intrinsics/Undispatched.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CoroutineScope(context) {
  return new (ContextScope())(!(context.get_y2st91_k$(Key_instance) == null) ? context : context.plus_s13ygv_k$(Job()));
}
function get_isActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_isActive_quafmh_k$();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
}
function ensureActive_0(_this__u8e3s4) {
  return ensureActive(_this__u8e3s4.get_coroutineContext_115oqo_k$());
}
function *coroutineScope(block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var coroutine = new (ScopeCoroutine())(uCont.get_context_h02k06_k$(), uCont);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  };
}
function plus(_this__u8e3s4, context) {
  return new (ContextScope())(_this__u8e3s4.get_coroutineContext_115oqo_k$().plus_s13ygv_k$(context));
}
function cancel(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.cancel_hkmm2i_k$(cause);
}
//region block: exports
export {
  coroutineScope as coroutineScope2qhrb6lhutwsn,
  CoroutineScope as CoroutineScopelux7s7zphw7e,
  cancel as cancel36mj9lv3a0whl,
  ensureActive_0 as ensureActivem48bojk66pw0,
  get_isActive as get_isActivehakov5bm97hw,
  plus as plusypd30qeai057,
};
//endregion

//# sourceMappingURL=CoroutineScope.mjs.map
